import { render, staticRenderFns } from "./MyPlans-user.vue?vue&type=template&id=40c9fc47&scoped=true"
import script from "./MyPlans-user.vue?vue&type=script&lang=js"
export * from "./MyPlans-user.vue?vue&type=script&lang=js"
import style0 from "./MyPlans-user.vue?vue&type=style&index=0&id=40c9fc47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9fc47",
  null
  
)

export default component.exports